import fetch from '../utils/fetch';

export default function makeService(endpoint) {
  return {
    find(id) {
      return fetch(`${id}`);
    },
    findSub(id,subname) {
      return fetch(`${id}/${subname}`);
    },
    findAll(params) {
      return fetch(endpoint, params);
    },
    findAllData(params,data) {
      return fetch(`${endpoint}/data/${data}`, params);
    },
    create(payload) {
      return fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) });
    },
    del(item) {
      return fetch(item['@id'], { method: 'DELETE' });
    },
    update(payload) {
      return fetch(payload['@id'], {
        method: 'PUT',
        body: JSON.stringify(payload)
      });
    },
    data(data) {
      return fetch(`${endpoint}/data/${data}`);
    },
    action(action,payload) {
      return fetch(`${endpoint}/action/${action}`, { method: 'POST', action: payload });
    },
    upload(params) {
      return fetch('media_objects/action/upload', { method: 'POST',  upload: params });
    },
    deleteImage(params) {
      return fetch('media_objects/action/delete', { method: 'POST',  delete: params });
    },
    download(params) {
      return fetch('media_objects/action/download', { method: 'POST',  download: params });
    },
  };
}
